export const PRODUCTS_LIST_TITLE = 'My Products List';
